module.exports = __webpack_public_path__ + "img/4.5e3efe8c.jpg";